import { render, staticRenderFns } from "./operate.vue?vue&type=template&id=f96750f2&scoped=true&"
import script from "./operate.vue?vue&type=script&lang=js&"
export * from "./operate.vue?vue&type=script&lang=js&"
import style0 from "./operate.vue?vue&type=style&index=0&id=f96750f2&scoped=true&lang=scss&ref=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96750f2",
  null
  
)

export default component.exports